import CustomSelect from '../../../../forms/CustomSelect'
import CustomSelectBlockedItems from '../../../../forms/CustomSelect/CustomSelectBlockedItems'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { notHaveCountersWorkingCenter } from '../../../../utils/globals/order/order'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { getActiveCurrenciesDictionary, getAllWorkingCenters } from '../../../../utils/reducers/getters'
import { useMemo } from 'react'


interface ModalConflictComponentProps {
    field: string
    pos: number
    header: TwinDictionary
    handleConflict: (field: string, value: string, pos: number) => void
    label: string
}
 interface OrderWorkingCenterIdCustomSelectProps extends ModalConflictComponentProps { }

export const OrderWorkingCenterIdCustomSelect: React.FC<OrderWorkingCenterIdCustomSelectProps> = ({ field, header, handleConflict, label, pos }) => {
    const workingCenters = useMemo(() => getAllWorkingCenters(), [])
    return (
        <CustomSelectBlockedItems className='my-auto' label={label} items={workingCenters || {}} value={header[field]} onChange={(val)=>handleConflict(field, val, pos)} blockItemsFnc={notHaveCountersWorkingCenter} />
    )
}

export interface OrderCurrencyIdCustomSelectProps extends ModalConflictComponentProps { }

export const OrderCurrencyIdCustomSelect: React.FC<OrderCurrencyIdCustomSelectProps> = ({ field, header, handleConflict, pos }) => {
    const { t } = useTwinTranslation()
    const activeCurrencies = getActiveCurrenciesDictionary()
    return (
        <CustomSelect className='my-auto' label={t('currency', 'Moneda')} items={activeCurrencies} value={header[field]} onChange={(val)=> handleConflict(field, val, pos)} />
    )
}